<template>
	<div class="file-viewer-src-input">
		<CombinedInputFieldDataMenu
			readonly
			:hasDelete="true"
			:textAreaMode="false"
			:value.sync="multiFileViewerSrc"
			:attachTo="'.file-viewer-src-input'"
			placeholder="Choose files to preview"
			:valuesTypes="dataInputMenuValueTypes"
		/>
	</div>
</template>

<script>
import { MULTI_FILE_VIEWER } from '@/utils/widget-service.const';
import { widgetMetadata } from '@/store/modules/widgetEditor/getters';
import { setWidgetOption } from '@/store/modules/widgetEditor/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu.vue';
import { TABLE_ONLY_ALLOWED_VALUE_TYPES } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';
export default {
	name: 'MultiFileViewerSettings',
	components: { CombinedInputFieldDataMenu },
	computed: {
		...mapGettersShorthand({ widgetMetadata }),
		multiFileViewer() {
			return this.widgetMetadata.options[MULTI_FILE_VIEWER] || { enabled: true, value: '' };
		},
		multiFileViewerSrc: {
			get() {
				return this.multiFileViewer.value;
			},
			set(value) {
				this.setWidgetOption({ key: MULTI_FILE_VIEWER, value: { value, enabled: true } });
			},
		},
	},
	methods: {
		...mapActionsShorthand({ setWidgetOption }),
	},
	data() {
		return {
			dataInputMenuValueTypes: TABLE_ONLY_ALLOWED_VALUE_TYPES,
		};
	},
};
</script>
